<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:29:22
 * @LastEditTime: 2019-08-13 19:34:22
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            title="物流码明细"
            :visible="true"
            width="60%"
            :before-close="handleClose">
        <!--表格-->
        <el-button type="primary" style='margin-bottom:10px;' @click='exportData'>导出明细</el-button>
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                border
                stripe
                height="250"
                style="width: 100%">
            <el-table-column
                    prop="stock_out_sn"
                    label="相关出货单号"
                   
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="product_sn"
                    label="产品编号"
                   >
            </el-table-column>
            <el-table-column
                    prop="product_name"
                    label="产品名称"
                    >
            </el-table-column>
                <el-table-column
                    prop="product_specs"
                    label="产品规格"
                   >
            </el-table-column>
              <el-table-column
                    prop="real_stock_out_num"
                    label="入库数量"
                   >
            </el-table-column>
              <el-table-column
                    prop="logistics_code"
                    label="物流码"
                   >
            </el-table-column>
              <el-table-column
                    prop="code_type"
                    label="标签类型"
                   >
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>

    </el-dialog>
</template>

<script>
    export default {
        name: "instock-detail",
        props: {
            detailData: {
                type: String,
                default: ' '
            },
        },
        data() {
            return {
                loading:false,
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                tableData:[]
            }
        },
        methods: {
            getData(){
                let url = '/inwarehouses/' + this.detailData + '/detail';
                this.loading =true;
                this.$get('logistics_1',url, {
                    per_page:this.pageSize,
                    page:this.pageNo,
                    inwarehouse:this.detailData,
                    lang:''
                }).then(res => {
                    this.loading =false;
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading =false;
                });
            },
            exportData(){
                   var access_tokens = localStorage.getItem('access_token');
                    var url=process.env.VUE_APP_URL_V1+'/inwarehouses/'+this.detailData+'/detail.export?'+'is_export=1'+'&signature='+ this.$md5(access_tokens)
                    window.open(
                        url
                    )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getData();
            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            this.getData();
        },
    }
</script>

<style lang="scss" scoped>

</style>